import useSWR from 'swr'

import { clinicAPI } from '~/api'
import { useCurCluster, useCurOrg } from '~/hooks/state'

import { Severity } from './types'

const DEFAULT_LIMIT = 20

export const useListEvents = ({
  keys,
  from,
  to,
  type,
  name,
  severity,
  cursor
}: {
  keys?: (string | number | undefined)[]
  from: number
  to: number
  type?: string
  name?: string
  severity?: number
  cursor?: string
}) => {
  const { clusterId, orgId } = useOrgClusterInfo()
  return useSWR(
    ['/list_events', keys],
    () =>
      clinicAPI.activityhubApplicationsApplicationIdTargetsTargetIdActivitiesGet(
        orgId,
        clusterId,
        from,
        to,
        // '1372813089208281359',
        // '1379661944636804070',
        // 1666789200,
        // 1670839223,
        undefined,
        type,
        name,
        severity,
        DEFAULT_LIMIT,
        cursor
      ),
    { revalidateIfStale: false, revalidateOnFocus: false }
  )
}

export const useGetEvent = ({ eventId }: { eventId: string }) => {
  const { clusterId, orgId } = useOrgClusterInfo()
  return useSWR(['/get_event', eventId], () =>
    clinicAPI.activityhubApplicationsApplicationIdTargetsTargetIdActivitiesActivityIdGet(
      orgId,
      clusterId,
      // '1372813089208281359',
      // '1379661944636804070',
      eventId
    )
  )
}

export const useListEventGroups = ({
  timeRange,
  severity = Severity.Info
}: {
  timeRange: [number, number]
  severity?: number
}) => {
  const { clusterId, orgId } = useOrgClusterInfo()
  return useSWR(['/list_groups', timeRange, severity], () =>
    clinicAPI.activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsGet(
      orgId,
      clusterId,
      timeRange[0],
      timeRange[1],
      // '1372813089208281359',
      // '1379661944636804070',
      // 1666789200,
      // 1670839223,
      severity
    )
  )
}

export const useGetGroup = ({ groupId }: { groupId: string }) => {
  const { clusterId, orgId } = useOrgClusterInfo()
  return useSWR(['/get_group', groupId], () =>
    clinicAPI.activityhubApplicationsApplicationIdTargetsTargetIdActivitygroupsContextIdGet(
      orgId,
      clusterId,
      // '1372813089208281359',
      // '1379661944636804070',
      groupId
    )
  )
}

const useOrgClusterInfo = () => {
  const { curOrg } = useCurOrg()
  const { curCluster } = useCurCluster()
  return {
    orgId: curOrg?.id!,
    clusterId: curCluster?.id!,
    projectId: curCluster?.projectID!
  }
}
